// Shared class strings so buttons, inputs and surfaces look the same on every page.

export const btnPrimary =
  "bg-honeConnectPurple text-white px-4 py-2 rounded-lg text-sm font-semibold border border-honeConnectPurple hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-honeConnectPurple/40";

export const btnSecondary =
  "bg-white text-honeConnectPurple px-4 py-2 rounded-lg text-sm font-semibold border border-honeConnectPurple hover:bg-hc_F4EBFA transition disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-honeConnectPurple/40";

export const btnGhost =
  "bg-white text-honeConnectGray px-3 py-2 rounded-lg text-sm font-medium border border-hcBorder hover:bg-hcBg transition focus:outline-none focus:ring-2 focus:ring-honeConnectPurple/30";

export const inputBase =
  "bg-white text-honeConnectBlack border border-hcBorder rounded-lg text-sm px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-honeConnectPurple/30 focus:border-honeConnectPurple";

export const card = "bg-white rounded-xl shadow-card border border-hcBorder";
